<script lang="ts">
    export let value: number
    export let unit: string = null
    let className = ""
    export {className as class}
    $: sign = Math.sign(value)
</script>

<span class={className} class:text-red-600={sign===-1} class:text-green-600={sign===1}>
    {Intl.NumberFormat("en-US", {signDisplay:"always"}).format(value)}{#if unit}{unit}{/if}
</span>